import { Routes, Route, Navigate } from 'react-router-dom';
import { AppShell } from './ui/AppShell';
import { CaptureRoute } from './routes/CaptureRoute';
import { ReviewRoute } from './routes/ReviewRoute';
import { ExportRoute } from './routes/ExportRoute';
import { AccountRoute } from './routes/AccountRoute';
import { PrivacyRoute } from './routes/PrivacyRoute';
import { ShareRoute } from './routes/ShareRoute';
import { SignInRoute } from './routes/SignInRoute';
import { NotFoundRoute } from './routes/NotFoundRoute';

/**
 * Route set for v1: capture → review → export, plus the account/privacy/share surfaces
 * (card t_31859fc7 §6-§7).
 *
 * `/share/:token` sits OUTSIDE the shell on purpose: a share recipient has no account, so the
 * page must not render nav, Clerk widgets or anything that assumes a signed-in coach.
 */
export default function App() {
  return (
    <Routes>
      <Route path="/share/:token" element={<ShareRoute />} />
      <Route element={<AppShell />}>
        <Route path="/" element={<Navigate to="/capture" replace />} />
        <Route path="/capture" element={<CaptureRoute />} />
        <Route path="/review" element={<ReviewRoute />} />
        <Route path="/export" element={<ExportRoute />} />
        <Route path="/account" element={<AccountRoute />} />
        <Route path="/privacy" element={<PrivacyRoute />} />
        <Route path="/sign-in/*" element={<SignInRoute />} />
        <Route path="*" element={<NotFoundRoute />} />
      </Route>
    </Routes>
  );
}
